import React from "react";
import { Helmet } from "react-helmet-async";
import { Link, useLocation } from "react-router-dom";
import styled from "styled-components";
import LabsHeader from "../Components/LabsHeader.jsx";
import { labsPalette } from "../labs/palette.js";

// Reached when a catalog card points at a service whose page is not in this bundle:
// the service was registered before its page deployed, or this tab still has an old build.
export default function LabServicePendingPage() {
  const location = useLocation();
  return <Shell>
    <Helmet><title>준비 중인 서비스 | 로우로우 랩스</title></Helmet>
    <LabsHeader back />
    <Content>
      <h1>이 서비스는 준비 중이에요</h1>
      <p>아직 열 수 있는 화면이 없어요. 새로 배포된 서비스라면 잠시 후 다시 열어 주세요.</p>
      <Actions>
        <button type="button" onClick={() => window.location.reload()}>다시 열기</button>
        <Link to={{ pathname: "/lab", search: location.search }}>랩스 목록으로</Link>
      </Actions>
    </Content>
  </Shell>;
}

const Shell = styled.div`min-height: 100vh; background: ${labsPalette.background}; color: ${labsPalette.text}; font-family: Pretendard, -apple-system, sans-serif;`;
const Content = styled.main`
  max-width: 560px; margin: 0 auto; padding: 24px 24px max(32px, env(safe-area-inset-bottom)); text-align: center;
  h1 { font-size: 22px; font-weight: 700; margin: 32px 0 12px; }
  p { color: ${labsPalette.muted}; font-size: 15px; line-height: 1.6; margin: 0 0 24px; }
  @media (max-width: 599px) { padding-left: 20px; padding-right: 20px; }
`;
const Actions = styled.div`
  display: flex; justify-content: center; gap: 12px; flex-wrap: wrap;
  button, a { display: inline-flex; align-items: center; min-height: 44px; padding: 0 18px; border-radius: 24px; font: inherit; font-size: 14px; text-decoration: none; box-sizing: border-box; }
  button { background: ${labsPalette.action}; color: #fff; border: 0; }
  a { border: 1px solid ${labsPalette.border}; color: inherit; }
`;
